module.exports = __webpack_public_path__ + "verify-id-icon.487ad793.png";